const ApiData = {
    SERVER_URL: 'https://fakestoreapi.com/products/',
};

export default ApiData;
